import { getLateCancelTransactions } from '@/utils/bookingTypes/resolvers';

export function iconType(value) {
  switch (Number(value)) {
    case 1:
      return 'city';
    case 2:
      return 'airport';
    case 3:
      return 'train-station';
    case 4:
      return 'harbour';
    case 5:
      return 'bus';
    case 6:
      return 'island';
    case 7:
      return 'point';
    case 8:
      return 'point';
    case 9:
      return 'harbour';
    // no default
  }
  // no return statement
}

export function currency(value = 0) {
  return value;
}

export function currencyIcon(code) {
  const icons = {
    USD: '\u0024',
    EUR: '\u20AC',
    RUB: '\u20BD',
  };

  return icons[code.toUpperCase()];
}

export function decodeHtml(value) {
  const txt = document.createElement('textarea');
  txt.innerHTML = value;
  return txt.value;
}

export function claimFineAmount(claims = []) {
  const cl = getLateCancelTransactions(claims).shift();
  return cl && cl.length > 0 ? `${cl[0].amount} ${cl[0].currency.code}` : '';
}

export function gmtFormat(time, offsetMinutes) {
  const offsetHour = Math.floor(offsetMinutes / 60);
  return `${time} (GMT${offsetHour >= 0 ? '+' : ''}${offsetHour})`;
}



// WEBPACK FOOTER //
// ./src/utils/Filters.js